import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";

// Layouts
import { AdminLayout } from "./components/AdminLayout";

// Pages
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import ItemList from "./pages/ItemList";
import ItemForm from "./pages/ItemForm";
import ShoesList from "./pages/ShoesList";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Redirect root to admin dashboard or login */}
            <Route path="/" element={<Navigate to="/admin" replace />} />
            
            {/* Protected Admin Routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="clothinglist" element={<ItemList />} />
              <Route path="clothinglist/new" element={<ItemForm />} />
              <Route path="clothinglist/:id" element={<ItemForm />} />
              <Route path="shoes" element={<ShoesList />} />
              <Route path="shoes/new" element={<ItemForm />} />
              <Route path="shoes/:id" element={<ItemForm />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            
            {/* 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
